// extracted by mini-css-extract-plugin
module.exports = {"header":"AddPricetypeModal_header_1kli4","wrapper":"AddPricetypeModal_wrapper_1S2xf"};